/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createRangeClass } from '../../factoriesAny.js';
export var RangeDependencies = {
  createRangeClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRangeClass.generated.js
// module id = 1448
// module chunks = 2